import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth"
import 'react-phone-number-input/style.css'

import api from "assets/services/api";


function ModalAddCars(props) {

    const { storageId } = useAuth();

    const [model, setModel] = useState();
    const [plate, setPlate] = useState();
    const [capacity, setCapacity] = useState();
    const [address, setAddress] = useState();
    const [latitude, setLatitude] = useState();
    const [longitude, setLongitude] = useState();
    const [number, setNumber] = useState();
    const [neighborhood, setNeighborhood] = useState();
    const [city, setCity] = useState();
    const [uf, setUf] = useState();
    const [cep, setCep] = useState();

    const [br, setBR] = useState(false);
    const [controlSnack, setControlSnack] = useState(false);

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (controlSnack) showNotification("br")
    }, [controlSnack]);

    async function handleAddCar(e) {
        e.preventDefault();
        try {

            const response = await api.post('/car', {
                model,
                plate: plate,
                capacity: capacity,
                id: storageId,
                latitude,
                longitude,
                address,
                number,
                neighborhood,
                city,
                uf,
                cep
            });
            console.log(response.data, response.status)
            props.getAllCars();
            props.onHide();
        } catch (error) {
            return alert("Erro ao adicionar carro: \n Ddados obrigatorios: Modelo, Placa e capacidade");
        }
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Adicionar Carro
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleAddCar}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridname_car">
                            <Form.Label>Modelo</Form.Label>
                            <Form.Control onChange={event => setModel(event.target.value)} value={model} type="text" placeholder="Modelo da carro" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridPlate">
                            <Form.Label>Placa</Form.Label>
                            <Form.Control onChange={event => setPlate(event.target.value)} value={plate} type="text" placeholder="Placa do carro" />
                        </Form.Group>
                        <Form.Group as={Col} controlId="formGridCapacity">
                            <Form.Label>Capacidade</Form.Label>
                            <Form.Control onChange={event => setCapacity(event.target.value)} value={capacity} type="number" placeholder="Capacidade do carro" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} xs={4} controlId="formGridname_car">
                            <Form.Label>Endereço</Form.Label>
                            <Form.Control onChange={event => setAddress(event.target.value)} value={address} type="text" placeholder="Endereço" />
                        </Form.Group>
                        <Form.Group as={Col} xs={1} controlId="formGridPlate">
                            <Form.Label>Numero</Form.Label>
                            <Form.Control onChange={event => setNumber(event.target.value)} value={number} type="text" placeholder="Numero" />
                        </Form.Group>
                        <Form.Group as={Col} xs={3} controlId="formGridCapacity">
                            <Form.Label>Bairro</Form.Label>
                            <Form.Control onChange={event => setNeighborhood(event.target.value)} value={neighborhood} type="text" placeholder="Bairro" />
                        </Form.Group>
                        <Form.Group as={Col} xs={3} controlId="formGridCapacity">
                            <Form.Label>Cidade</Form.Label>
                            <Form.Control onChange={event => setCity(event.target.value)} value={city} type="text" placeholder="Cidade" />
                        </Form.Group>
                        <Form.Group as={Col} xs={1} controlId="formGridCapacity">
                            <Form.Label>Estado</Form.Label>
                            <Form.Control onChange={event => setUf(event.target.value)} value={uf} type="text" placeholder="Estado" />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row className="d-flex justify-content-center">
                        <Form.Group as={Col} xs={2} controlId="formGridname_car">
                            <Form.Label>CEP</Form.Label>
                            <Form.Control onChange={event => setCep(event.target.value)} value={cep} type="text" placeholder="cep" />
                        </Form.Group>
                        <Form.Group as={Col} xs={2} controlId="formGridname_car">
                            <Form.Label>Latitude</Form.Label>
                            <Form.Control onChange={event => setLatitude(event.target.value)} value={latitude} type="text" placeholder="Latitude" />
                        </Form.Group>
                        <Form.Group as={Col} xs={2} controlId="formGridPlate">
                            <Form.Label>Longitude</Form.Label>
                            <Form.Control onChange={event => setLongitude(event.target.value)} value={longitude} type="text" placeholder="Longitude" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Adicionar carro
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Carro adicionado com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalAddCars;